import axios from 'axios';

// Use your local proxy server
const PROXY_URL = 'http://localhost:5000/api/adzuna';

export const fetchAdzunaJobs = async (searchQuery = '', location = 'us') => {
  try {
    // When no search query is provided, avoid defaulting to a narrow term like "developer".
    // Use a randomized, generic term to broaden the results and simulate "random" discovery.
    const genericTerms = [
      'assistant', 'manager', 'sales', 'marketing', 'customer', 'support',
      'operations', 'coordinator', 'specialist', 'associate', 'analyst',
      'technician', 'driver', 'warehouse', 'retail', 'healthcare', 'nurse',
      'teacher', 'admin', 'hospitality', 'construction'
    ];
    const effectiveQuery = (searchQuery && searchQuery.trim().length > 0)
      ? searchQuery.trim()
      : genericTerms[Math.floor(Math.random() * genericTerms.length)];

    const params = {
      what: effectiveQuery,
      location: location,
      results_per_page: 10
    };

    const response = await axios.get(PROXY_URL, { params });

    // Transform Adzuna job data to match our app's job format
    return response.data.results.map(job => ({
      id: `adzuna_${job.id}`,
      title: job.title,
      company: job.company?.display_name || job.company_name,
      location: job.location.display_name,
      description: job.description,
      requirements: job.required_skills?.join('\n') || '',
      salary: job.salary_is ? `$${job.salary_min}-${job.salary_max}` : 'Not specified',
      jobType: job.contract_type || 'Full-time',
      industry: job.category.label,
      isExternal: true,
      externalUrl: job.redirect_url,
      createdAt: new Date(job.created),
      logo: job.company_logo_url || null
    }));
  } catch (error) {
    console.error('Error fetching Adzuna jobs:', error);
    return [];
  }
}; 